import { Link } from "react-router-dom";
import { useContext, useState } from "react";

// importing components
import { Row, Col, Button, message, Progress, Divider, Checkbox } from "antd";
import ProductSlider from "../Sliders/ProductSlider/ProductSlider";
import moment from "../../config/moment";

// importing styles
import styles from "./CartScreen.module.scss";

// importing icons
import { AiFillPlusCircle, AiFillMinusCircle } from "react-icons/ai";
import { IoCloseOutline } from "react-icons/io5";

// importing images

import discount_49_off_image from "./images/discount_49_off_image.png";

//importing context
import { CartContext } from "../../Contexts/CartContext";
import CartTable from "./CartTable";
import CartOrderSummary from "../CartOrderSummary/CartOrderSummary";
import CartTableMobile from "./CartTableMobile";
import {
  BestSellingProducts,
  LifeChangeSlider,
  RecommendedProducts,
} from "../../Views/LandingV2/LandingV2";
import { FiArrowRight, FiEdit2 } from "react-icons/fi";
import DeliveryMethods from "../../Views/CartCheckout/DeliveryMethods";
import Tips from "../../Views/CartCheckout/Tips";
import { AuthContext } from "../../Contexts/AuthContext";
import { GrClose } from "react-icons/gr";

const CartScreen = ({
  setStep,
  step,
  orderPlaceHandler,
  setShipping,
  setPersonal,
}) => {
  const cartContext = useContext(CartContext);
  const { isAuthenticated, user } = useContext(AuthContext);
  const [showBuyNowPop, setShowBuyNowPop] = useState(true);
  const [agree, setAgree] = useState(false);

  return (
    <>
      <div>
        <Row gutter={[14, 14]}>
          <Col xs={24} className={"mb_only"}>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  width: "100%",
                }}
              >
                <div>
                  {cartContext.calculateOrderSubTotal() > 39.99 ? (
                    <>
                      <div
                        style={{
                          background: "#F7EAC8",
                          display: "flex",
                          gap: "10px",
                          padding: ".5rem 1rem",
                          alignItems: "center",
                        }}
                      >
                        <img
                          src="https://desi-fresh.b-cdn.net/misc/df-db-hand.svg"
                          alt=""
                        />
                        <span style={{ fontSize: "13px" }}>
                          Congrats! You get a free shipping on this order
                        </span>
                      </div>
                    </>
                  ) : (
                    <>
                      <Progress
                        strokeColor={{
                          "0%": "var(--color-primary)",
                          "100%": "#87d068",
                        }}
                        percent={
                          (100 * cartContext.calculateOrderSubTotal()) / 39.99
                        }
                        showInfo={false}
                        status="active"
                      />
                      <span>
                        Please add{" "}
                        <span
                          style={{
                            fontSize: "1.6rem",
                            fontWeight: "bold",
                            color: "var(--color-dark)",
                          }}
                        >
                          €
                          {parseFloat(
                            49.99 - cartContext.calculateOrderSubTotal()
                          ).toFixed(2)}
                        </span>{" "}
                        worth product to obtain free delivery
                      </span>
                    </>
                  )}
                </div>
              </div>
            </div>
          </Col>

          <div style={{width: "100vw"}}>
                  <RecommendedProducts />
          </div>
          
          <Col lg={18} xs={24}>
            <div className={styles.cart_table_wrapper}>
              <CartTable />
            </div>
            <div className={styles.cart_table_mobile}>
              <CartTableMobile />
            </div>

            <FloatingCartButton setStep={setStep} step={step} />
          </Col>
          {window.innerWidth <= 576 && (
            <Col lg={6} xs={24}>
              <DeliveryMethods />
            </Col>
          )}
          <Col lg={6} xs={24}>
            <CartOrderSummary
              cartContext={cartContext}
              step={step}
              setStep={setStep}
            />
          </Col>

          {window.innerWidth > 576 && (
            <Col lg={24}>
              <DeliveryMethods />
            </Col>
          )}

          <Col lg={24} xs={24}>
            <Tips />
          </Col>
        </Row>

        <br />
        <LifeChangeSlider />
      </div>

      {/*Mobile Recurring Direct Checkout Pop Up*/}
      {isAuthenticated && showBuyNowPop && user.s_first_name && (
        <div
          className={
            styles.direct_checkout +
            " d-flex flex-column align-items-center gap-3 mb_only"
          }
        >
          <div
            className={styles.direct_checkout__close}
            onClick={() => setShowBuyNowPop(false)}
          >
            <GrClose size={15} />
          </div>

          <span className={"fw-bold"}>Your Order</span>
          <div className={styles.order_box}>
            <img
              src="https://desi-fresh.b-cdn.net/components_static/Orders/desi_box.svg"
              alt=""
            />
          </div>
          <span className={"fw-bold"}>
            Expected Delivery Date:{" "}
            {moment().add(2, "days").format("DD MMM YYYY")}
          </span>
          <Divider style={{ margin: 0 }} />
          <div style={{ width: "100%" }}>
            <div className={styles.dc_item}>
              <b>Delivery to:</b>
              <span>
                {user.s_title} {user.s_first_name} {user.s_last_name},{" "}
                {user.s_house_no}, {user.s_street_address}, {user.s_city},
                Germany
              </span>
              <FiEdit2 size={20} onClick={() => setStep(2)} />
            </div>
            <div className={styles.dc_item}>
              <b>Shipped by:</b>
              <span className={"text-uppercase"}>
                {cartContext.deliveryMethod}
              </span>
              {/*<FiEdit2 size={20}/>*/}
            </div>
            <div className={styles.dc_item}>
              <b>Pay with:</b>
              <span>
                {cartContext.paymentMethod === "card"
                  ? "Card/Stripe"
                  : cartContext.paymentMethod}
              </span>
              <FiEdit2
                size={20}
                onClick={() => {
                  let shipping = {
                    title: user.s_title,
                    phone_prefix: "49",
                    country: "Germany",
                    first_name: user.s_first_name,
                    last_name: user.s_first_name,
                    street_address: user.s_street_address,
                    house_no: user.s_house_no,
                    zip_code: user.s_zip_code,
                    state: user.s_state,
                    city: user.s_city,
                    email: user.s_email,
                    phone_number: user.s_phone_number,
                  };

                  let personal = {
                    title: user.b_title,
                    phone_prefix: "49",
                    country: "Germany",
                    first_name: user.b_first_name,
                    last_name: user.b_first_name,
                    street_address: user.b_street_address,
                    house_no: user.b_house_no,
                    zip_code: user.b_zip_code,
                    state: user.b_state,
                    city: user.b_city,
                    email: user.b_email,
                    phone_number: user.b_phone_number,
                  };

                  setShipping(shipping);
                  setPersonal(personal);

                  setStep(3);
                }}
              />
            </div>
            <div className={styles.dc_item}>
              <b>Amount:</b>
              <span>{cartContext.calculateOrderTotal()} €</span>
            </div>
          </div>
          <div
            className={styles.recommended_and_continue + " mb_only"}
            style={{ position: "relative", margin: 0, left: 0, bottom: 0 }}
          >
            <div className={styles.recommended}>
              <Button
                type="primary"
                block
                size="large"
                className={styles.proceed_to_next_btn}
                onClick={() => {
                  if (!agree) {
                    message.error(
                      "Please agree to Desi Fresh Terms & Conditions!"
                    );
                  } else {
                    orderPlaceHandler();
                  }
                }}
              >
                <div style={{ display: "flex", alignItems: "center" }}>
                  <img
                    src="https://desi-fresh.b-cdn.net/misc/checkout.svg"
                    alt="checkout_icon"
                    style={{ marginRight: "10px" }}
                  />
                  <span style={{ fontWeight: 600 }}>BUY NOW</span>
                  <FiArrowRight size={18} style={{ marginLeft: "1rem" }} />
                </div>
                <div className={styles.proceed_to_next_btn__right}>
                  <em>{cartContext.calculateOrderTotal()} €</em>
                  {step !== 4 && <span>Inclusive of VAT</span>}
                </div>
              </Button>
              <div className={styles.secure_payment}>
                <img src="/icon/checkout/lock.svg" alt="" />
                Secure Payment Guaranteed
              </div>
            </div>
          </div>
          {/*@mrshofiq - Connect Links*/}
          <Checkbox
            checked={agree}
            onChange={(e) => setAgree(e.target.checked)}
          >
            By placing this order you agree to Desi Fresh{" "}
            <Link
              to={"/"}
              style={{
                color: "var(--color-primary)",
                textDecoration: "underline",
              }}
            >
              Terms & Conditions
            </Link>
            , Please see our{" "}
            <Link
              to={"/"}
              style={{
                color: "var(--color-primary)",
                textDecoration: "underline",
              }}
            >
              Privacy Notice
            </Link>{" "}
            &{" "}
            <Link
              to={"/"}
              style={{
                color: "var(--color-primary)",
                textDecoration: "underline",
              }}
            >
              Cookies
            </Link>
            .
          </Checkbox>
        </div>
      )}
    </>
  );
};

export default CartScreen;

export const CartItemPrice = ({ item }) => {

  const itemOrderPrice = parseFloat(item.order_time_price).toFixed(2);
  const itemVariantPrice = parseFloat(item.variant.price).toFixed(2);
  const hasDiscount = itemVariantPrice > itemOrderPrice;

  return (
    <div className={styles.cart_item_price}>
      <span className={styles.item_price}>{itemOrderPrice} €</span>
      {hasDiscount ? <span className={styles.original_price}>{itemVariantPrice} €</span> : null}
    </div>
  );
}

export const CartItem = ({ item }) => {
  const cartContext = useContext(CartContext);

  const addToCart = () => {
    cartContext.addToCart(item);
  };

  const increaseQty = () => {
    addToCart();
  };

  const decreaseQty = () => {
    if (item.quantity - 1 < 1) {
    } else {
      cartContext.cartItemDecrement(item.id);
    }
  };

  return (
    <tr className={styles.cartItemTableRow}>
      <td>
        <img className={styles.product_image} src={item.image} alt="img" />
      </td>
      <td>
        <div className={styles.table_product_wrapper}>
          <div className={styles.title_and_variant}>
            <p style={{ color: "var(--color-primary)" }}>
              {item.title} {item.product?.tax_rate == 7.0 ? "(A)" : "(B)"}
            </p>
            <p>Quantity:{" "} {item.variant?.value}</p>
            <p>
              Brand:{" "}
              <span
                style={{
                  color: "var(--color-primary)",
                  fontWeight: "bold",
                  textDecoration: "underline",
                }}
              >
                {item.product.brand.name}
              </span>
            </p>
          </div>

          <div className={styles.express_delivery_text}>
          </div>
        </div>
      </td>
      <td>
        <div className={styles.product_quantity_actions}>
          <AiFillMinusCircle
            size={18}
            onClick={decreaseQty}
            color={"var(--color-primary)"}
          />
          <div className={styles.stock_amount}>{item.quantity}</div>
          <AiFillPlusCircle
            size={18}
            onClick={increaseQty}
            color={"var(--color-primary)"}
          />
        </div>
      </td>
      <td><CartItemPrice item={item} /></td>
      <td>
        <div style={{ display: "flex", alignItems: "center", height: "100%" }}>
          <span style={{ fontWeight: 500 }}>
            {parseFloat(item.order_time_price * item.quantity).toFixed(2)} €
          </span>
          <div
            className={styles.cross}
            onClick={() => cartContext.removeFromCart(item.id)}
          >
            <IoCloseOutline size={25} onClick={null} />
          </div>
        </div>
        <Link className={styles.product_details} to={`/products/${item.slug}`}>
          Product details
        </Link>
      </td>
    </tr>
  );
};

export const FloatingCartButton = ({
  setStep,
  step,
  shippingForm,
  personalForm,
  orderPlaceHandler,
}) => {
  const cartContext = useContext(CartContext);

  const handleOnCick = () => {
    if (step === 2) {
      personalForm.submit();
      shippingForm?.submit();
    } else if (step === 4) {
      orderPlaceHandler();
    } else {
      cartContext.cartItems.length > 0
        ? setStep(step + 1)
        : message.error("Your cart is empty!");
    }
  };

  return (
    <div className={styles.recommended_and_continue + " mb_only"}>
      <div className={styles.recommended}>
        <Button
          type="primary"
          block
          size="large"
          className={styles.proceed_to_next_btn}
          onClick={handleOnCick}
        >
          <div style={{ display: "flex", alignItems: "center" }}>
            <img
              src="https://desi-fresh.b-cdn.net/misc/checkout.svg"
              alt="checkout_icon"
              style={{ marginRight: "10px" }}
            />
            <span style={{ fontWeight: 600, fontSize: 18 }}>
              {step === 1
                ? "Proceed to Checkout"
                : step === 2
                  ? "Payment Method"
                  : step === 3
                    ? "Review & Confirm"
                    : "Place Order"}
            </span>
            <FiArrowRight size={18} style={{ marginLeft: "1rem" }} />
          </div>
          <div className={styles.proceed_to_next_btn__right}>
            <em>{cartContext.calculateOrderTotal()} €</em>
            {step !== 4 && <span>Inclusive of VAT</span>}
          </div>
        </Button>
        <div className={styles.secure_payment}>
          <img src="/icon/checkout/lock.svg" alt="" />
          Secure Payment Guaranteed
        </div>
      </div>
    </div>
  );
};
